import React,{ useState } from "react";
import "./navbar1.css";
import ChatIcon from "../images/speech-bubble.png";
import User from "../images/user.png";
import Noti from "../images/bell.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-regular-svg-icons';
import {faUser} from '@fortawesome/free-regular-svg-icons';
import {faComment} from '@fortawesome/free-regular-svg-icons';

export default function Navbar() {
    return(
        // <div className="nav-div">
        //     <a><img src={Noti} className="icons-nav"></img></a>
        //     <a><img src={ChatIcon} className="icons-nav"></img></a>
        //     <a><img src={User} className="icons-nav"></img></a>
        // </div>
        <div class="nav-bar">

  <a href="view-influencer"><FontAwesomeIcon icon={faUser} /> </a>
  <a href="/chat"><FontAwesomeIcon icon={faComment} /></a> 
  <a href="#"><FontAwesomeIcon icon={faBell} /></a> 
</div>
    )
}
